import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Fade } from 'react-reveal';
import { Container } from 'components/shared';
import { TestimonialType } from 'types';
import { media, theme } from 'styles';
import Testimonial from './components/Testimonial';

const Wrapper = styled(Container)`
  position: relative;
  margin-top: 96px;

  ${media.laptop`
    display: flex;
    flex-align: flex-start;
    justify-content: space-between;
  `};
`;

const TestimonialWrapper = styled.div`
  &:first-child {
    margin-bottom: ${theme.sp.xxl};
    border-bottom: 1px solid ${theme.colors.border};
    padding-bottom: ${theme.sp.xxl};

    ${media.laptop`
      margin-bottom: 0;
      border-bottom: 0;
      padding-bottom: 0;
    `};
  }

  ${media.laptop`
    max-width: calc((100% - 64px) / 2);
  `};

  ${media.max`
    max-width: 460px;
  `};
`;

const Divider = styled.div`
  display: none;
  position: absolute;
  top: 100px;
  left: calc(50% - 0.5px);
  height: 80%;
  min-height: 200px;
  width: 1px;
  background-color: ${theme.colors.border};
  ${media.laptop`
    display: block;
  `};
`;

const propTypes = {
  testimonials: PropTypes.arrayOf(TestimonialType).isRequired,
};

function Testimonials({ testimonials }) {
  return (
    <Wrapper>
      {testimonials.map(testimonial => (
        <TestimonialWrapper key={testimonial.id}>
          <Fade>
            <Testimonial testimonial={testimonial} />
          </Fade>
        </TestimonialWrapper>
      ))}
      <Divider />
    </Wrapper>
  );
}

Testimonials.propTypes = propTypes;

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/Testimonials/Testimonials.jsx